import { Injectable } from '@angular/core';
import FingerprintJS from '@fingerprintjs/fingerprintjs';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class FingerPrintService {
  visitorIdSubject = new BehaviorSubject<string | null>(null);
  visitorId$ = this.visitorIdSubject.asObservable();

  constructor() {}
  async getFingerprint(): Promise<void> {
    const fp = await FingerprintJS.load();
    const result = await fp.get();
    this.visitorIdSubject.next(result.visitorId);
  }
}
